import {GET_ORDERS} from '../types';
import axios from 'axios';
import {timeFrom, timeTo} from "../../utils/timeInterval";
import {domain, formatDbDate, naturalUrlAttr, ordersStructure} from "../../config";

export const getOrders = () => async dispatch => {
    try {
        const response = await axios.get(`${domain}trade/final?${naturalUrlAttr}`);


        const orders = response.data.map(order => {

            const newOrder = {};

            newOrder.amountForOper = order.AmountForOper;
            newOrder.amountForOperCurr = order.AmountForOperCurr;
            newOrder.clientOrderId = order.ClientOrderId;
            newOrder.baseCurr = order.BaseCurr;
            newOrder.cycleStage = order.CycleStage;
            newOrder.cycleEnd = order.CycleEnd;
            newOrder.fdTime = order.FdTime;
            newOrder.feeCurr = order.FeeCurr;
            newOrder.feeResult = order.FeeResult;
            newOrder.isRobotOrder = order.IsRobotOrder === 0 ? ordersStructure.isRobotOrder.no : ordersStructure.isRobotOrder.yes;
            newOrder.IterBuy = order.IterBuy;
            newOrder.IterSell = order.IterSell;
            newOrder.loadTime = order.LoadTime;
            newOrder.OrderAlg = order.OrderAlg;
            newOrder.orderAmount = order.OrderAmount;
            newOrder.orderAmountCurr = order.OrderAmountCurr;
            newOrder.orderAmountForOperExec = order.OrderAmountForOperExec;
            newOrder.orderAmountForOperExecCurr = order.OrderAmountForOperExecCurr;
            newOrder.orderExec = order.OrderExec;
            newOrder.orderExecCurr = order.OrderExecCurr;
            newOrder.orderId = order.OrderID;
            newOrder.orderIdPaired = order.OrderIdPaired;
            newOrder.orderOrigAmount = order.OrderOrigAmount;
            newOrder.orderOrigAmountCurr = order.OrderOrigAmountCurr;
            newOrder.orderPrice = order.OrderPrice;
            newOrder.orderRemains = order.OrderRemains;
            newOrder.orderRemainsCurr = order.OrderRemainsCurr;
            newOrder.pair = order.Pair;
            newOrder.sdTime = order.SdTime;
            newOrder.side = order.Side;
            newOrder.status = order.Status;
            newOrder.TargIdx = order.TargIdx;
            newOrder.time = order.Time;
            newOrder.timeInForce = order.TimeInForce;
            newOrder.txCNT = order.TxCNT;
            newOrder.type = order.Typ;
            newOrder.user_id = order.User_id;

            let date_number;
            let time;

            if (newOrder.fdTime === null || newOrder.fdTime === 0) {
                date_number = +newOrder.sdTime;
                time = +newOrder.sdTime;
            } else {
                date_number = +newOrder.fdTime;
                time = +newOrder.fdTime;
            }

            let date = new Date(date_number);
            let daymth = date.getDate() + '_' + date.getMonth();

            return {
                ...newOrder,
                time,
                date_number,
                daymth: daymth,
                dateTime: date
            };
        });

        const correctDatesOrders = orders.filter((order) => {

            if (order.status !== 'PARTIALLY_FILLED' && order.status !== 'NEW') {
                return order.date_number >= +timeFrom && order.date_number <= +timeTo;
            } else {
                return order.date_number >= +timeFrom;
            }
        });

        let sideValuesSet = new Set();
        let statusValuesSet = new Set();
        let typeValuesSet = new Set();
        let OrderAlgValuesSet = new Set();
        let isRobotOrderSet = new Set();
        let cycleEndSet = new Set();
        let cycleStageSet = new Set();
        let baseCurrSet = new Set();

        correctDatesOrders.forEach(order => {
            sideValuesSet.add(order.side);
            statusValuesSet.add(order.status);
            typeValuesSet.add(order.type);
            isRobotOrderSet.add(order.isRobotOrder);

            if (order.cycleEnd) {
                cycleEndSet.add(order.cycleEnd);
            }

            if (order.cycleStage) {
                cycleStageSet.add(order.cycleStage);
            }

            if (order.baseCurr) {
                baseCurrSet.add(order.baseCurr);
            }

            if (order.OrderAlg) {
                OrderAlgValuesSet.add(order.OrderAlg);
            }
        });

        dispatch({
            type: GET_ORDERS,
            payload: {
                items: correctDatesOrders,
                isLoad: true,
                sideValuesSet: Array.from(sideValuesSet),
                statusValuesSet: Array.from(statusValuesSet),
                typeValuesSet: Array.from(typeValuesSet),
                OrderAlgValuesSet: Array.from(OrderAlgValuesSet),
                isRobotOrderSet: Array.from(isRobotOrderSet),
                cycleEndSet: Array.from(cycleEndSet),
                cycleStageSet: Array.from(cycleStageSet),
                baseCurrSet: Array.from(baseCurrSet),
            }
        });
    } catch (e) {
        console.log('error orders');
    }
};
